import { render, staticRenderFns } from "./StatementGenerator.vue?vue&type=template&id=5f037bfb&"
import script from "./StatementGenerator.vue?vue&type=script&lang=js&"
export * from "./StatementGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports